function isCrumbResult(value: unknown): value is { crumb: string } {
  return (
    typeof value === 'object' &&
    value !== null &&
    !('then' in value) &&
    'crumb' in value &&
    typeof value.crumb === 'string'
  );
}

/**
 * A route's breadcrumb from the parameterless `loader: () => ({ crumb })`
 * shape that carries authored copy, or null. Loaders that take arguments need
 * router context or a record, so they aren't called; neither is a result
 * that is a promise. The crumb is still `msg()`-encoded.
 */
export function readStaticCrumb(loader: unknown): string | null {
  if (typeof loader !== 'function' || loader.length !== 0) return null;
  try {
    const loaded: unknown = loader();
    return isCrumbResult(loaded) ? loaded.crumb : null;
  } catch {
    return null;
  }
}
